var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_left_26x48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.472292 23.3322C0.351415 23.3322 0.230539 23.2859 0.138465 23.1938C-0.046155 23.0092 -0.046155 22.7108 0.138465 22.5262L10.6646 12L0.138465 1.47384C-0.046155 1.28922 -0.046155 0.99081 0.138465 0.80619C0.323085 0.62157 0.621499 0.62157 0.806119 0.80619L11.9999 12L0.806119 23.1938C0.714045 23.2859 0.593168 23.3322 0.472292 23.3322Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.5d8bb46c6e06f6c4f0b2d8e83bb46f61.svg";
export { ForwardRef as ReactComponent };